import { ConfigStateService } from '@abp/ng.core';
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { ActivatedRoute, Router } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ArtikelGruppen } from '../../store/models/artikelgruppen';
import { NavService } from '../nav/shared/nav.service';
import { WebfrontService } from '../../artikels/shared/webfront.service';
import { Webfront } from '../../store/models/webfront';
import { GridsterConfig,  GridsterItem }  from 'angular-gridster2';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { WarenkorbsService } from '../warenkorbs/shared/warenkorbs.service';
import { CurrentUserComponent } from '@abp/ng.theme.basic';

@Component({
    selector: 'app-webshop-checkout',
    templateUrl: './checkout.component.html',
    styleUrls: ['./checkout.component.scss']
})
export class CheckoutComponent implements OnInit, AfterViewInit {

  
    // Utils
    isLoading: boolean = true;


    firstFormGroup: FormGroup;
    secondFormGroup: FormGroup;

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private navService: NavService,
        private oAuthService:OAuthService,
        private config: ConfigStateService,
        private warenkorbServicve:WarenkorbsService,
        private _formBuilder: FormBuilder
            ) {
              
                
    }

    ngAfterViewInit(): void {
       this.isLoading=false;
    }

    //rechnungAdr;
    ngOnInit(): void {

    
        this.warenkorbServicve.getRechnungsadresse().subscribe(x=>
            {
                //this.rechnungAdr=x;
                var adr = (x.anrede != null ?  x.anrede +"<br>" : '');
                
                adr += ((x.vorname != null ? x.vorname : '') + ' ' +(x.nachname != null ? x.nachname : '')).trim();
                
                adr += "<br>" + (x.firmenname != null ? x.firmenname : '');
                adr += "<br>" + (x.strasse != null ? x.strasse : '');
                adr += "<br>" + (x.plz != null ? x.plz : '') + ' ' + (x.ort != null ? x.ort : '');
                
                document.getElementById("checkout_adr").innerHTML = adr;
                
            });          
    
        this.warenkorbServicve.getPaymentterm().subscribe(x=>
            {
                document.getElementById("checkout_paymentterm").innerHTML = x["paymentterm"];                        
            });   
                   

        this.firstFormGroup = this._formBuilder.group({
            addrType: ['auto', Validators.required],
            firstCtrl: ['']
          });
        //this.secondFormGroup = this._formBuilder.group({
          //  secondCtrl: ['', Validators.required]
        //});

    }
    
}